<div *ngIf="dataLoading">
  <h3 style="text-align:center;">LOADING TO DO TODAY</h3>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<div class="container" style="width:100%" *ngIf="!dataLoading && tasks.length">
  <mat-table
    [dataSource]="dataSource"
    matSort
    matSortActive="due"
    matSortDirection="asc"
    class="mat-elevation-z2 stack-todo-table"
  >
    <ng-container matColumnDef="patient">
      <mat-header-cell *matHeaderCellDef> PATIENT </mat-header-cell>
      <mat-cell *matCellDef="let row" class="stack-wrap-cell">
        <button
          mat-button
          *ngIf="row.order.patient?._id"
          type="button"
          class="stack-patient-button"
          [routerLink]="['/admin/patient', row.order.patient._id]"
        >
          {{ patientName(row.order) }}
        </button>
        <span *ngIf="!row.order.patient?._id">{{ patientName(row.order) }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="invoiceNumber">
      <mat-header-cell *matHeaderCellDef> INVOICE # </mat-header-cell>
      <mat-cell *matCellDef="let row" class="stack-wrap-cell">
        <span [class.priority-redo-invoice]="row.order?.redoPriority">{{ invoiceLabel(row.order) }}</span>
        <span class="fulfillment-ship-badge" *ngIf="isShipTask(row)">SHIP</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="task">
      <mat-header-cell *matHeaderCellDef mat-sort-header> TASK </mat-header-cell>
      <mat-cell *matCellDef="let row" class="stack-wrap-cell">
        <strong>{{ row.task }}</strong>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="due">
      <mat-header-cell *matHeaderCellDef mat-sort-header> DUE </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span *ngIf="row.due">{{ row.due | date:'M/d/yy' }}</span>
        <span *ngIf="!row.due">—</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="view">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let row" class="stack-icon-cell">
        <button
          mat-icon-button
          type="button"
          class="stack-view-order-button"
          (click)="openOrder(row.order)"
          aria-label="Open job"
        >
          <mat-icon>visibility</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="log">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let row" class="stack-icon-cell">
        <app-log-menu [order]="row.order" [small]="true" [alwaysShow]="true"></app-log-menu>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</div>
